export const defaultLoadingConfig = {
    lock: true,
    text: 'Carregando',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
}